import { SemanticMetricsHomeSection } from '@features/semantic-layer';
import { Box } from '@mui/material';

import { useDashboardConfig } from '../hooks/useDashboardConfig';

import { ComplianceBadges } from './ComplianceBadges';
import { DashboardRenderer } from './DashboardRenderer';
import { Header } from './Header';

/**
 * Dashboard V2 - Config-Driven Dashboard Implementation
 *
 * This dashboard uses a data-driven architecture where:
 * - All state is aggregated in a single hook (useDashboardState)
 * - Business rules determine which cards to show (cardRules)
 * - Components are dynamically rendered from a registry (cardRegistry)
 * - The dashboard itself is just a layout engine
 *
 * Benefits:
 * - Single source of truth for dashboard logic
 * - Easy to test business rules in isolation
 * - Ready for server-driven UI (config could come from API)
 * - Prepared for future features like personalization and A/B testing
 */
export const Dashboard = () => {
  // Get dashboard configuration based on current state and business rules
  const config = useDashboardConfig();
  return (
    <>
      {/*
      TODO: Commenting out the outer Box for now -> until new Navbar is implemented ... when that happens we might also make this the app bg and delete this
      <Box
        sx={{
          width: '100%',
          minHeight: '100%',
          bgcolor: 'background.default',
        }}
      > */}
      <Box
        sx={{
          mx: 'auto',
          maxWidth: 1312,
          py: 5,
          px: { xs: 2, sm: 3, md: 4 },
          display: 'flex',
          flexDirection: 'column',
          gap: 5,
        }}
      >
        <Header />

        <SemanticMetricsHomeSection />

        {/* Render dashboard cards based on configuration */}
        <DashboardRenderer config={config}>
          {/* ComplianceBadges passed as children to appear after cards */}
        </DashboardRenderer>

        <ComplianceBadges />
      </Box>
      {/* </Box> */}
    </>
  );
};

export default Dashboard;
